import { Box } from "@mui/material";

const cvPath = "/cv/Konstantinos-Panteli-CV.pdf";

const CvPage = () => (
    <Box
        component="iframe"
        src={cvPath}
        title="Konstantinos Panteli CV"
        sx={{
            display: "block",
            width: "100%",
            height: "100dvh",
            border: 0,
            backgroundColor: "#121212",
        }}
    />
);

export default CvPage;
